// farm-booking/frontend/src/pages/Maintenance.jsx
// Page maintenance - La Ferme du Petit Essart
// 73+ Papy

import './Maintenance.css'

function Maintenance() {
  return (
    <div className="maintenance-app">
      <div className="maintenance-wrap">
        <div className="maintenance-card">
          <div className="maintenance-icon">🔧</div>
          <h1 className="maintenance-title">Site en maintenance</h1>
          <p className="maintenance-message">
            Nous effectuons actuellement des travaux de maintenance pour améliorer votre expérience.
          </p>
          <p className="maintenance-sub">
            Nous serons de retour très bientôt !
          </p>
          <div className="maintenance-contact">
            <p>Pour toute urgence, contactez-nous :</p>
            <a href="mailto:contact@lafermedupetitessart.fr">contact@lafermedupetitessart.fr</a>
          </div>
        </div>
        <footer className="maintenance-footer">
          © 2025 La Ferme du Petit Essart – Grand-Couronne
        </footer>
      </div>
    </div>
  )
}

export default Maintenance
